export default __webpack_public_path__ + "static/media/756.8ba810c9.gif";